/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Blissful = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Blissful"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <circle cx={12} cy={12} r={10} fill="#FFC220" className="Fill-Main" />
      <path
        fill="#000"
        fillOpacity={0.5}
        fillRule="evenodd"
        d="M6.41 14.744a.833.833 0 0 1 1.18 0 6.24 6.24 0 0 0 8.82 0 .833.833 0 1 1 1.18 1.179 7.904 7.904 0 0 1-11.18 0 .833.833 0 0 1 0-1.179"
        className="Fill-Secondary"
        clipRule="evenodd"
      />
      <path
        fill="#F50"
        d="M9.367 7.833c1.004 0 1.8.821 1.8 1.633s-.447 1.448-1.342 2.18c-.89.73-1.197.803-1.996 1.187-.79-.384-1.096-.458-1.987-1.187-.895-.732-1.342-1.368-1.342-2.18s.797-1.633 1.8-1.633c.78 0 1.276.427 1.533.734.257-.307.754-.734 1.534-.734m8.333 0c1.003 0 1.8.821 1.8 1.633s-.447 1.448-1.342 2.18c-.89.729-1.197.803-1.995 1.187-.79-.384-1.097-.458-1.988-1.187-.895-.732-1.342-1.368-1.342-2.18s.797-1.633 1.8-1.633c.78 0 1.277.427 1.534.734.257-.307.753-.734 1.533-.734"
        className="Fill-Accent"
      />
    </g>
  </svg>
);

export const BlissfulIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'blissful-icon'}
      icon={Blissful}
      {...props}
      size={size}
    />
  );
};
